import React from "react";
import { Button } from '@mantine/core';
import { IconPlus, IconUpload } from '@tabler/icons-react';
import heic2any from "heic2any";

import { utils } from "../../utils/globalVariables";
import ModalResponse from "../../components/general/ModalResponse";

// info: ini component file selector, default accept nya ['image/*']. Pastikan file mana yg pakai compoenent ini, pastikan stateAcceptArrayFiles nya = ['image/*']

// info: MIME TYPE SOLVED
// info: HEIC CONVERTER SOLVED

const FileSelectorComponent = ({
    fnAddOnSelect,
    fnUploadLoading,
    stateUploadLoading = false,
    stateUploadProgress = '',
}) => {

    const refFileInput = React.useRef(null);

    const [data, setData] = React.useState({
        modalResponse: {
            show: false,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: false,
            content: ''
        }
    });

    const handleFileUpload = async (event) => {
        const file = event;

        fnUploadLoading(true);

        if (file && file.type === "image/heic") {
            try {
                const convertedBlob = await heic2any({ blob: file, toType: "image/jpeg" });
                const jpegFile = new File([convertedBlob], `${file.name}.jpeg`, { type: "image/jpeg" });
                refFileInput.current.value = '';
                fnAddOnSelect(jpegFile);
            } catch (error) {
                fnUploadLoading(false);

                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: 'Konversi HEIC gagal',
                        show: true
                    }
                }));
            }
        } else {
            refFileInput.current.value = '';
            fnAddOnSelect(file);
        }
    }

    const fileChecker = (e) => {
        try {
            const value = e.target.files[0];

            if (value && (typeof value === 'object')) {
                const tipe = value.type.split('/')[0];

                if (tipe !== 'image') {
                    refFileInput.current.value = '';

                    setData(d => ({
                        ...d,
                        modalResponse: {
                            ...d.modalResponse,
                            type: utils.modalResponse.warning,
                            hideOnClickOutSide: true,
                            content: 'Tipe file harus merupakan "image".',
                            show: true
                        }
                    }));
                } else {
                    handleFileUpload(value);
                }
            }
        } catch (error) {
            //
        }
    }

    return (
        <React.Fragment>
            <input
                type='file'
                ref={refFileInput}
                onChange={(e) => fileChecker(e)}
                style={{ display: 'none' }}
            />

            <Button
                variant="light"
                disabled={stateUploadLoading}
                color={`${stateUploadLoading ? 'gray' : 'blue'}`}
                size="xs"
                leftIcon={stateUploadLoading ? <IconUpload size={10} /> : <IconPlus size={10} />}
                styles={(theme) => ({
                    leftIcon: { marginRight: '3px' }
                })}

                onClick={!stateUploadLoading ? () => refFileInput.current.click() : () => { }}
            >
                {stateUploadLoading ? `${stateUploadProgress}%` : 'Foto'}
            </Button>

            <ModalResponse
                stateShow={data.modalResponse.show}
                fnHide={() => setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        show: false
                    }
                }))}

                stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
                stateType={data.modalResponse.type}
                stateContent={data.modalResponse.content}
            />
        </React.Fragment>
    )
}

export default FileSelectorComponent;